"use strict";
function $7bc9b28ce873737c$export$9ab68d8551785815(container) {
    if (document.querySelector(container)) document.querySelector(container).insertAdjacentHTML("beforeend", `
    <div class ='stockSlider__button__container'>
    <button class='stockSLider__button stockBtnLeft'> \u{2190} </button>
    <button class='stockSLider__button stockBtnRight'> \u{2192} </button>
    </div>`);
}


"use strict";
function $c5605fe46ee4137e$export$fcaff3454eb5084b(slider) {
    document.querySelectorAll(slider).forEach((s, i)=>{
        s.style.transform = `translateX(${100 * i}%)`;
    });
}


"use strict";
function $5528bbd8beef4422$export$5308b33ccc8c13bc(container, slider) {
    let curslide = 0;
    const maxslide = document.querySelectorAll(slider).length - 1;
    let isFalse = false;
    const intervalSLider = setInterval(()=>{
        if (!isFalse) {
            if (curslide === maxslide) {
                curslide = 0;
                document.querySelectorAll(slider).forEach((s, i)=>{
                    s.style.transform = `translateX(${100 * (i - curslide)}%)`;
                });
            } else {
                curslide++;
                document.querySelectorAll(slider).forEach((s, i)=>{
                    s.style.transform = `translateX(${100 * (i - curslide)}%)`;
                });
            }
        }
    }, 8000);
    if (document.querySelector(container)) {
        document.querySelector(container).addEventListener("mouseover", ()=>{
            isFalse = true;
        });
        document.querySelector(container).addEventListener("mouseout", ()=>{
            isFalse = false;
        });
        document.querySelector(container).addEventListener("touchstart", ()=>{
            isFalse = true;
        });
        document.querySelector(container).addEventListener("touchmove", ()=>{
            isFalse = true;
        });
        document.querySelector(container).addEventListener("touchend", ()=>{
            isFalse = false;
        });
    }
    if (document.querySelector(".stockBtnRight") && document.querySelector(".stockBtnLeft")) {
        document.querySelector(".stockBtnRight").addEventListener("click", ()=>{
            if (curslide === maxslide) {
                curslide = 0;
                document.querySelectorAll(slider).forEach((s, i)=>{
                    s.style.transform = `translateX(${100 * (i - curslide)}%)`;
                });
            } else {
                curslide++;
                document.querySelectorAll(slider).forEach((s, i)=>{
                    s.style.transform = `translateX(${100 * (i - curslide)}%)`;
                });
            }
        });
        document.querySelector(".stockBtnLeft").addEventListener("click", ()=>{
            if (curslide === 0) {
                curslide = maxslide;
                document.querySelectorAll(slider).forEach((s, i)=>{
                    s.style.transform = `translateX(${100 * (i - curslide)}%)`;
                });
            } else {
                curslide--;
                document.querySelectorAll(slider).forEach((s, i)=>{
                    s.style.transform = `translateX(${100 * (i - curslide)}%)`;
                });
            }
        });
    }
}


"use strict";
(0, $c5605fe46ee4137e$export$fcaff3454eb5084b)(".ss-kombinat");
(0, $5528bbd8beef4422$export$5308b33ccc8c13bc)(".sc-kombinat", ".ss-kombinat");
(0, $c5605fe46ee4137e$export$fcaff3454eb5084b)(".ss-review");
(0, $7bc9b28ce873737c$export$9ab68d8551785815)(".sc-review");
(0, $5528bbd8beef4422$export$5308b33ccc8c13bc)(".sc-review", ".ss-review");


//# sourceMappingURL=about.516a3f17.js.map
